export default __webpack_public_path__ + "static/media/gnl9.dfee13da.png";